export const backendEnv = {
    url: 'https://backendcursos.johnhanleyphd.com'
   // url: 'http://localhost:8000'
}

export const endpoints = {
    login: '/api/public/v1/user/login',
    getUser: '/api/public/v1/user/get',
    updateUser: '/api/public/v1/user/update',
    changePwd: '/api/public/v2/user/password/change',
    getCourses: '/api/public/v1/course/get',
    getCourse: '/api/public/v2/course/get',
    getCourseDuration: '/api/public/v2/course/get_duration',
    logout: '/api/public/v1/user/logout',
    register: '/api/public/v1/user/register',
    requestPasswordReset: '/api/public/v1/user/request/reset',
    passwordReset: '/api/public/v1/user/password/reset',
    getServerLang: '/api/public/v2/lang/get',
    setServerLangEn: '/api/public/v1/lang/set/en',
    setServerLangEs: '/api/public/v1/lang/set/es',
    messageSend: '/api/public/v1/message/send',
    updateTime: '/api/v1/time/update',
    getTime: '/api/v1/time/get',
    getCourseSell: '/api/public/v1/coursesell/',
    createPayIntent: '/api/v1/stripe/payintent',
    getStripeGateway:'/api/v1/stripegateway/get',
    getIntentPay: '/api/v1/stripe/get'
    
}